import { Observable } from "rxjs";

export function createResizeObservable(
  element: HTMLElement,
): Observable<DOMRectReadOnly> {
  return new Observable((observer) => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        observer.next(entry.contentRect);
      }
    });

    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  });
}
